import {Component, Input, OnInit} from '@angular/core';
import {Tab} from '../../../tabbing/data/tab';

@Component({
  selector: 'app-settings-page',
  templateUrl: './settings-page.component.html',
  styleUrls: ['./settings-page.component.scss']
})
export class SettingsPageComponent implements OnInit {
  @Input() tab: Tab;

  selectedTabName: string = 'General';
  tabHeadersIcons: string[] = ['fas fa-phone', 'fas fa-envelope'];
  tabHeaders: string[] = ['General', 'Emailing'];

  constructor() { }

  ngOnInit(): void {
  }

  onTabChange(tabName: string) {
    this.selectedTabName = tabName;
  }

}
